// extracted by mini-css-extract-plugin
module.exports = {"oven-nav":"OvenNav_oven-nav__1f0No","oven-nav__button":"OvenNav_oven-nav__button__2haGl"};